<template>
    <div class="relative h-6 w-6">
        <component :is="icon" class="absolute h-full w-full opacity-30" :class="color" aria-hidden="true" />
        <component :is="icon" class="absolute h-full w-full" :class="color" :style="{ clipPath: 'inset(30% 0% 0% 0%)' }"
            aria-hidden="true" />
    </div>
</template>

<script>
export default {
    name: 'DuotoneIcon',
    props: {
        icon: {
            type: Object,
            required: true,
        },
        color: {
            type: String,
            default: 'text-gray-400',
        },
    },
};
</script>